import ReactGA from 'react-ga';

// providers
import { UserProvider } from "providers/UserProvider";
import { TimelineProvider } from "providers/TimelineProvider";
import { PreferenceProvider } from "providers/PreferenceProvider";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import DeviceOrientation, { Orientation } from "react-screen-orientation";
import NoSleep from "nosleep.js";

// components
import ThemedApp from "ThemedApp";
import Lottie from "react-lottie";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

//assets
import loadingAnimation from "assets/lotties/loading2.json";
import { Button, Typography } from "@mui/material";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const [isLoading, setIsLoading] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);
  const [loaded, setLoaded] = useState(0);
  const [total, setTotal] = useState(4);
  const [keepAwakeState, setKeepAwakeState] = useState(false);
  const noSleep = new NoSleep();
  ReactGA.initialize('G-8L8ZG08HBF');

  useEffect(() => {
    if (keepAwakeState) {
      noSleep.enable();
    } else {
      noSleep.disable();
    }
  }, [keepAwakeState]);

  // useEffect(() => {
  //   const URLS_TO_PRECACHE = [
  //     "https://fs.shegeftangizan.com/timeline-single/jahanam_drums.mp3",
  //     "https://fs.shegeftangizan.com/timeline-single/jahanam_voc1.mp3",
  //     "https://fs.shegeftangizan.com/timeline-single/jahanam_voc2.mp3",
  //     "https://fs.shegeftangizan.com/timeline-single/jahanam_instruments.mp3",
  //   ];
  //   for (let url of URLS_TO_PRECACHE) {
  //     navigator.serviceWorker?.controller?.postMessage({
  //       type: "CACHE_CHECK",
  //       cacheTitle:"jahanam",
  //       url,
  //     });
  //     // navigator.serviceWorker.postMessage({data:{type:"CACHE_CHECK",url:}})
  //   }
  //   // navigator.serviceWorker.
  // }, []);

  useEffect(() => {
    // if (!navigator.serviceWorker.controller) {
    // console.log("initialize message listener");
    navigator.serviceWorker.addEventListener("message", (event) => {
      if(event.data.type === "URL_CACHE_COMPLETE"){
          // console.log("URL CAHCE COMPLETE! ",event.data.cacheTitle,event.data.url)
          return
      }
      
      // console.log("serviceWorkerSays: ", event.data);
      const { urlsCached, totalURLs } = event.data;
      // console.log("serviceWorkerSays: ", event.data);
      setTotal(totalURLs);
      setLoaded(urlsCached);
      if (urlsCached === totalURLs) {
        setIsLoading(false);
      }
      // Display a message about how many URLs have been cached.
    });
    // }
  }, []);
  return (
    <>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "#ccccccd0",
            zIndex: 1000000,
          }}
        >
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: loadingAnimation,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
            height={"50%"}
            width={window.innerHeight > window.innerWidth ? "100%" : "40%"}
          />

          <p
            style={{
              textAlign: "center",
            }}
          >
            LOADING... {`${loaded}/${total}`}
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "center",
              width: "fit-content",
              position: "relative",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "white",
            }}
          >
            <Typography>Keep Screen Awake</Typography>
            <ToggleButtonGroup
              value={keepAwakeState}
              exclusive
              onChange={(event, newValue) => {
                setKeepAwakeState(newValue);
              }}
            >
              <ToggleButton value={true}>ON</ToggleButton>
              <ToggleButton value={false}>OFF</ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>
      )}

      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <TimelineProvider>
            <PreferenceProvider>
              <ThemedApp />
            </PreferenceProvider>
          </TimelineProvider>
        </UserProvider>
      </QueryClientProvider>
    </>
  );
}

//           {/* <UserProvider> */}

//           {/* </UserProvider> */}
//         {/* </QueryClientProvider> */}

export default App;
